import { TicketMessageFragment, TicketActivityFragment } from "src/graphql/generated/types";

export const getMessagesWithActivities = (
  messages: Array<TicketMessageFragment>,
  activities: Array<TicketActivityFragment>
) =>
  [...messages, ...activities].sort((a, b) => {
    return Date.parse(a.createdAt) - Date.parse(b.createdAt);
  });
